import { render, staticRenderFns } from "./VentanaUsuario.vue?vue&type=template&id=6b5b81cd&scoped=true&"
import script from "./VentanaUsuario.vue?vue&type=script&lang=js&"
export * from "./VentanaUsuario.vue?vue&type=script&lang=js&"
import style0 from "./VentanaUsuario.vue?vue&type=style&index=0&id=6b5b81cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b81cd",
  null
  
)

export default component.exports